var exports = {
  "kL": "xa15a2ab7--2878c5--container",
  "sL": "xa15a2ab7--2878c5--container--active",
  "Sx": "xa15a2ab7--2878c5--play-button",
  "_$": "xa15a2ab7--2878c5--tour-thumb",
};

module.exports = exports;
